import { motion } from 'motion/react'
import styled from 'styled-components'

export const Shape = styled(motion.div)<{ $color: string }>`
  position: absolute;
  inset: 0;
  background: ${({ $color }) => $color};
  transform-origin: bottom left;
`
